import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa";
import logoImg from "./images/dodoaplogo.png";
import "./Navbar.css";

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  // Close menu when route changes
  useEffect(() => {
    closeMenu();
  }, [location.pathname]);

  // Prevent body scroll when menu is open
  useEffect(() => {
    if (isOpen) {
      document.body.classList.add("menu-open");
    } else {
      document.body.classList.remove("menu-open");
    }
    
    return () => {
      document.body.classList.remove("menu-open");
    };
  }, [isOpen]);

  // Close menu on escape key
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === "Escape" && isOpen) {
        closeMenu();
      }
    };

    document.addEventListener("keydown", handleEscape);
    return () => document.removeEventListener("keydown", handleEscape);
  }, [isOpen]);

  return (
    <nav className="navbar" role="navigation" aria-label="Glavna navigacija">
      <div className="nav-container">
        <Link 
          to="/" 
          className="nav-logo" 
          onClick={closeMenu} 
          aria-label="Početna stranica"
        >
          <img 
            src={logoImg} 
            alt="Dodo upravljanje nekretninama logo" 
            className="hero__logo" 
            loading="eager" 
            width="50" 
            height="50" 
          />
          <span className="hero__title">Dodo upravljanje nekretninama</span>
        </Link>

        <button
          className={`menu-icon ${isOpen ? "active" : ""}`}
          onClick={toggleMenu}
          aria-label={isOpen ? "Zatvori meni" : "Otvori meni"}
          aria-expanded={isOpen}
          type="button"
        >
          {isOpen ? (
            <FaTimes aria-hidden="true" size={24} />
          ) : (
            <FaBars aria-hidden="true" size={24} />
          )}
        </button>

        {/* Overlay for mobile */}
        <div 
          className={`menu-overlay ${isOpen ? "active" : ""}`}
          onClick={closeMenu}
          aria-hidden="true"
        />

        <ul className={isOpen ? "nav-menu active" : "nav-menu"}>
          <li>
            <Link
              to="/upravljanje-smjestajem"
              className="nav-link"
              onClick={closeMenu}
            >
              Upravljanje smještajem
            </Link>
          </li>
          <li>
            <Link
              to="/cleaningservice"
              className="nav-link"
              onClick={closeMenu}
            >
              Čišćenje
            </Link>
          </li>
          <li>
            <Link 
              to="/housemaster" 
              className="nav-link" 
              onClick={closeMenu}
            >
              Kućni majstor
            </Link>
          </li>
          <li>
            <a
              href="https://dodouredenje.com.hr"
              className="nav-link"
              target="_blank"
              rel="noopener noreferrer"
              onClick={closeMenu}
            >
              Uređenje okućnice
            </a>
          </li>
          <li>
            <Link 
              to="/kontakt" 
              className="nav-link" 
              onClick={closeMenu}
            >
              Kontakt
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
}
